module.exports = __webpack_public_path__ + "static/media/SCM.1298e4d6.svg";